// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SiteNav-style__wrapper__75368980","items":"SiteNav-style__items__75368980","item":"SiteNav-style__item__75368980","itemLink":"SiteNav-style__itemLink__75368980","dropdownContent":"SiteNav-style__dropdownContent__75368980","dropdownHeader":"SiteNav-style__dropdownHeader__75368980 Dropdown-style__headerTitle__296ffdc0","dropdownCol":"SiteNav-style__dropdownCol__75368980","dropdownSection":"SiteNav-style__dropdownSection__75368980","dropdownLink":"SiteNav-style__dropdownLink__75368980"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SiteNav/SiteNav-style.scss
// module id = ./src/components/SiteNav/SiteNav-style.scss
// module chunks = 4